<template>
  <div class="time-bar">
    <div class="time-bar__inner">
      <div class="time-bar__pic">
        <img :src="`${staticPath}img/factory/test/time_bar.png`">
      </div>
      <div class="time-bar__bar" :style="{transform: timerBarTransformStyle}"></div>
      <div class="time-bar__time">{{ timerText }}</div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  @import '@/assets/scss/modules.scss';

  .time-bar {
    position: relative;
    padding: 10px 0;
  }

  .time-bar__inner {
    position: relative;
  }

  .time-bar__pic {
    position: relative;
    width: 100%;
    padding: 5px 0;
    z-index: 101;
  }

  .time-bar__bar {
    position: absolute;
    width: calc(100% - 15px);
    height: 15px;
    top: 10px;
    left: 10px;
    right: 5px;
    border-radius: 10px 0 0 10px;
    background-color: #11a2fd;
    z-index: 100;
    transform-origin: 0 50%;

    @include mq_sp_s {
      height: 10px;
    }
    //transform: scaleX(0.5);
  }

  .time-bar__time {
    position: absolute;
    top: 50%;
    right: 10px;
    width: 80px;
    height: 30px;
    margin-top: -12px;
    z-index: 102;
    color: #a9392d;
    font-size: 24px;
    font-family: 'Menlo', 'Courier', 'Courier New', 'Consolas', monospace, sans-serif;
    font-weight: 700;
    text-align: right;
    text-shadow: 
    #fff 2px 0px,  #fff -2px 0px,
    #fff 0px -2px, #fff 0px 2px,
    #fff 2px 2px , #fff -2px 2px,
    #fff 2px -2px, #fff -2px -2px,
    #fff 1px 2px,  #fff -1px 2px,
    #fff 1px -2px, #fff -1px -2px,
    #fff 2px 1px,  #fff -2px 1px,
    #fff 2px -1px, #fff -2px -1px;
  }
</style>

<script>
  import Constant from '@/constant';

  export default {
    name: 'TimeBar',
    props: ['timerMax', 'timerStop', 'timerInitStart'], // タイマーMAX秒 タイマーを止める

    data(){
      return {
        staticPath: Constant.STATICPATH,
        timerText: '00:00',  // タイマー表示用（秒:ミリ秒）
        timerBarTransformStyle: 'scaleX(1.0)',
        timerIntervalId: 0,
      }
    },

    created() {
      this.init();
    },

    methods: {

      init() {
        // TODO 1分以上の場合は表示を変える必要あり
        clearInterval(this.timerIntervalId);

        const TIMING = 10; // 10ミリ秒

        const timer_max_ms = this.timerMax * 1000; //タイマーのMAXをミリ秒に変換 
        let timer_cnt_ms = 0; // タイマーのカウンタ

        this.timerText = this.timerMax + ':00';

        this.timerIntervalId = setInterval(
          () => {

            timer_cnt_ms += TIMING;

            let rest_timer = timer_max_ms - timer_cnt_ms;  // 残り時間

            let rest_sec = Math.floor(rest_timer / 1000);  // 秒
            let rest_ms = (rest_timer - (rest_sec * 1000)) / TIMING;  //ミリ秒

            rest_sec = ('00' + rest_sec).slice(-2);
            rest_ms = ('00' + rest_ms).slice(-2);

            if (timer_cnt_ms > timer_max_ms ) {
              // タイムアウト
              clearInterval(this.timerIntervalId);

              //不正解
              this.$emit('check-answer', false);

            } else {
              this.timerText = rest_sec + ':' + rest_ms;

              const scale_x = rest_timer / timer_max_ms;
              this.timerBarTransformStyle = 'scaleX(' + scale_x + ')';
            }

          }, TIMING
        )
      }
    },

    watch: {

      timerInitStart(val) {

        if (val) {
          this.init();
        }
      },

      timerStop(val){
        
        if (val) {
          clearInterval(this.timerIntervalId);
        }
      }
    },

    beforeDestroy() {
      
      clearInterval(this.timerIntervalId);
    },
  }
</script>


// WEBPACK FOOTER //
// src/components/Study/Parts/Timebar.vue